export const usPriorities = [
  { country: 'USA', priority: 1 },
  { country: 'Canada', priority: 2 },
];
export const ukPriorities = [
  { country: 'UK', priority: 1 },
  { country: 'Ireland', priority: 2 },
];
export const dachPriorities = [
  { country: 'Germany', priority: 1 },
  { country: 'Switzerland', priority: 2 },
  { country: 'Austria', priority: 3 },
];
export const dePriorities = [
  { country: 'Deutschland', priority: 1 },
  { country: 'Schweiz', priority: 2 },
  { country: 'Österreich', priority: 3 },
];
export const menaPriorities = [
  { country: 'UAE', priority: 1 },
  { country: 'Saudi Arabia', priority: 2 },
  { country: 'Qatar', priority: 3 },
];

export const industriesPriority = [
  {
    industry: 'Financial Services',
    priority: 1,
  },
  {
    industry: 'Healthcare',
    priority: 2,
  },
  {
    industry: 'Automotive',
    priority: 3,
  },
  {
    industry: 'Enterprise',
    priority: 4,
  },
  {
    industry: 'Logistics',
    priority: 5,
  },
  {
    industry: 'eCommerce',
    priority: 6,
  },
  {
    industry: 'Retail',
    priority: 7,
  },
];

export const industriesPriorityDe = [
  {
    industry: 'Finanzen',
    priority: 1,
  },
  {
    industry: 'Gesundheitswesen',
    priority: 2,
  },
  {
    industry: 'Medien & Unterhaltung',
    priority: 3,
  },
  {
    industry: 'Unternehmen',
    priority: 4,
  },
  {
    industry: 'E-Commerce',
    priority: 5,
  },
  {
    industry: 'Automobilindustrie',
    priority: 6,
  },
  {
    industry: 'E-Learning',
    priority: 7,
  },
  {
    industry: 'Reise & Unterkunft',
    priority: 8,
  },
  {
    industry: 'Logistik',
    priority: 9,
  },
];

export const ALL_GALLERIES_KEY = 'project-gallery-all';
